import {FinancingRateMatrixCell, SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {ensureActiveFinancingCell} from './ensureActiveFinancingCell';

export function updateFinancingCell(
  body: SaveSaleVehicleFinancingBody,
  nextCell: FinancingRateMatrixCell
) {
  const cells = body.rateMatrix.cells.filter(
    (cell) =>
      !(
        cell.term === nextCell.term &&
        cell.downPayment === nextCell.downPayment &&
        cell.balloonPayment === nextCell.balloonPayment
      )
  );

  return ensureActiveFinancingCell({
    ...body,
    rateMatrix: {
      ...body.rateMatrix,
      cells: [...cells, nextCell],
    },
  });
}
